import { withChildren } from '@builder.io/react';
import { isDesktopFnc } from 'utils/deviceDetection';

import Flex from 'quarks/Flex';

import Section, { withAlwaysDarkSection } from 'molecules/Section/Section';

import type { ContentEditorProps } from 'components/ContentEditor/ContentEditor';
import AuthorCard from 'components/Sidebar/AuthorCard';
import PublishDate from 'components/Sidebar/PublishDate';
import Sidebar from 'components/Sidebar/Sidebar';
import SocialShareLink from 'components/Sidebar/SocialShareLinks';

import { ActiveContentProvider } from 'contexts/ContentEditorProvider';
import useAlwaysDark from 'contexts/SectionThemeProvider';

import type { Builder_EntityPerson } from 'graphqlTypes';
import type { FC } from 'react';

interface ArticleContentEditorProps extends ContentEditorProps {
  author: { value?: Builder_EntityPerson };
  authors?: { value?: Builder_EntityPerson }[];
  publishedDate?: Date;
}

const ContentEditor: FC<ArticleContentEditorProps> = ({ children, author, authors, publishedDate }) => {
  const isDesktop = isDesktopFnc();
  const { isAlwaysDark } = useAlwaysDark();

  return (
    <ActiveContentProvider>
      <Section backgroundColor={{ dark: 'common-black', light: 'gray-50', isAlwaysDark }}>
        <Flex
          flexDirection="column"
          justifyContent="space-between"
          gap="40px"
          lg={{ flexDirection: 'row', gap: '36px' }}
        >
          <Sidebar
            author={author?.value}
            authors={JSON.stringify(authors)}
            publishedDate={publishedDate}
            content={children || []}
            authorCard
            socialShare
            tableOfContents
            isSticky
          />
          <Flex flexDirection="column" gap="24px" width="100%" maxWidth="770px" css={{ scrollPaddingTop: '120px' }}>
            {children}
            <Flex flexDirection="column" gap="32px" marginTop={12}>
              {!isDesktop && (
                <>
                  {!author === undefined && <AuthorCard {...author?.value?.data} />}
                  <SocialShareLink />
                  {publishedDate && <PublishDate date={publishedDate} />}
                </>
              )}
            </Flex>
          </Flex>
        </Flex>
      </Section>
    </ActiveContentProvider>
  );
};

export default withChildren(withAlwaysDarkSection(ContentEditor));
